import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  ref: "elRef",
  class: "breadcrumbs"
};
function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")], 512);
}
import { ref } from 'vue';
export default {
  name: 'f7-breadcrumbs',
  render,
  props: {},
  setup() {
    const elRef = ref(null);
    return {
      elRef
    };
  }
};